import AppReader from "./reader/appReader";
import URLRouter from "./../common/utilities/URLRouter";

require.ensure(
  [],
  (require) => {
    require(`./../../clients/${process.env.CLIENT}/scss/index_web.scss`);
  },
  "css"
);

const urlRouter = new URLRouter();
const cpid = urlRouter.contentpackageId;
const pubid = urlRouter.publicationId;

if (!cpid) {
  console.log("URL is incorrect, could not parse out CPID"); // eslint-disable-line
}

new AppReader({
  contentPackageId: cpid,
  publicationId: pubid,
});



// WEBPACK FOOTER //
// ./src/web/reader.js